import {
  FETCH_STARTER_KIT_COMPONENTS_REQUEST,
  FETCH_STARTER_KIT_COMPONENTS_SUCCESS,
  FETCH_STARTER_KIT_COMPONENTS_FAILURE,

  CREATE_STARTER_KIT_COMPONENT_REQUEST,
  CREATE_STARTER_KIT_COMPONENT_SUCCESS,
  CREATE_STARTER_KIT_COMPONENT_FAILURE,

  UPDATE_STARTER_KIT_COMPONENT_REQUEST,
  UPDATE_STARTER_KIT_COMPONENT_SUCCESS,
  UPDATE_STARTER_KIT_COMPONENT_FAILURE,

  DELETE_STARTER_KIT_COMPONENT_REQUEST,
  DELETE_STARTER_KIT_COMPONENT_SUCCESS,
  DELETE_STARTER_KIT_COMPONENT_FAILURE,
} from "../actions/types";


const initialState = {
  starterKitComponents: [],

  loading: false,

  error: null,

  message: "",
};


const starterKitComponentReducer = (
  state = initialState,
  action
) => {

  switch (action.type) {



    case FETCH_STARTER_KIT_COMPONENTS_REQUEST:

      return {
        ...state,

        loading: true,

        error: null,
      };


    case FETCH_STARTER_KIT_COMPONENTS_SUCCESS:

      return {
        ...state,

        loading: false,

        starterKitComponents:
          action.payload || [],

        message:
          "Starter Kit Components loaded successfully",
      };


    case FETCH_STARTER_KIT_COMPONENTS_FAILURE:

      return {
        ...state,

        loading: false,

        error:
          action.payload,

        starterKitComponents: [],
      };



    case CREATE_STARTER_KIT_COMPONENT_REQUEST:

      return {
        ...state,

        loading: true,

        error: null,
      };


    case CREATE_STARTER_KIT_COMPONENT_SUCCESS:

      return {
        ...state,

        loading: false,

        starterKitComponents: [
          ...state.starterKitComponents,
          action.payload,
        ],

        message:
          "Starter Kit Component created successfully",
      };


    case CREATE_STARTER_KIT_COMPONENT_FAILURE:

      return {
        ...state,

        loading: false,

        error:
          action.payload,
      };


    case UPDATE_STARTER_KIT_COMPONENT_REQUEST:

      return {
        ...state,

        loading: true,

        error: null,
      };


    case UPDATE_STARTER_KIT_COMPONENT_SUCCESS:

      return {
        ...state,

        loading: false,

        starterKitComponents:
          state.starterKitComponents.map(
            (component) =>
              component.starter_kit_component_id ===
              action.payload.starter_kit_component_id
                ? action.payload
                : component
          ),

        message:
          "Starter Kit Component updated successfully",
      };


    case UPDATE_STARTER_KIT_COMPONENT_FAILURE:

      return {
        ...state,

        loading: false,

        error:
          action.payload,
      };



    case DELETE_STARTER_KIT_COMPONENT_REQUEST:

      return {
        ...state,

        loading: true,

        error: null,
      };


    case DELETE_STARTER_KIT_COMPONENT_SUCCESS:

      return {
        ...state,

        loading: false,

        starterKitComponents:
          state.starterKitComponents.filter(
            (component) =>
              component.starter_kit_component_id !==
              action.payload
          ),

        message:
          "Starter Kit Component deleted successfully",
      };


    case DELETE_STARTER_KIT_COMPONENT_FAILURE:

      return {
        ...state,

        loading: false,

        error:
          action.payload,
      };


    default:

      return state;
  }
};


export default starterKitComponentReducer;